/**
 * Logic for ShareLinks component (see also _ShareLinks.scss)
 * Trigger print, and open sharing links in a new window
 */
;(function(jQuery){
	"use strict";
	function ProjectsAbroadFaqs()
	{
		var global = {
		}

		var fn = {
			init: function()
			{
				jQuery('.js-scroll-transition').on('click', fn.handleScroll);
			},

			handleScroll: function(e)
			{
				e.preventDefault();
				var target = jQuery(this).attr('href');
				jQuery('html, body').animate({ scrollTop: jQuery(target).offset().top }, 400);
			},
		}

		jQuery(fn.init);
	}

	new ProjectsAbroadFaqs();
}($));
